<script setup lang="ts">
import SliderNavigation from '~/components/common/slider-navigation.vue'
import LiveStreamCard from '~/components/common/casino/live-stream-card.vue'
import { useSwiper } from '~/composables/common/use-swiper'
import { LIVE_CASINO_PATH } from '~/constants'

const streams = [
  {
    id: 'G1S_305',
    title: 'Tài Xỉu Live Bàn 4',
    provider: 'sunwin',
    streamId: '7MhcV-Pi0uG',
    groupId: '7652d5a1-11fd-4f52-bb74-933631fd78df',
    gameUrl: 'https://txlive.swgames.club/',
    posterSrc: '/assets/images/components/live-casino/livestream/tai-xiu-4.webp',
    level: { min: 1, max: 50_000 }
  },
  {
    id: 'G1S_306',
    title: 'Xóc Đĩa Live Bàn 4',
    provider: 'sunwin',
    streamId: '7MhcV-ZvYvo',
    groupId: 'c88ff431-0ee8-4faf-b375-1b515b20ae68',
    gameUrl: 'https://xdlive.swgames.club/',
    posterSrc: '/assets/images/components/live-casino/livestream/xoc-dia-4.webp',
    level: { min: 1, max: 50_000 }
  },
  {
    id: 'G1S_311',
    title: 'Sicbo X88 Live',
    provider: 'sunwin',
    streamId: 'G4BpH3',
    groupId: 'Da1Lws1aVDn3nsWStream2-1',
    gameUrl: 'https://sicbox88.swgames.club/',
    posterSrc: '/assets/images/components/live-casino/livestream/sicbo-x88.webp',
    level: { min: 1, max: 20_000 }
  },
  {
    id: 'G1X_305',
    title: 'Tài Xỉu Live Bàn 5',
    provider: '789',
    streamId: '7MhcV-weX7L',
    groupId: 'f23545d4-bbb0-416f-bbb7-972619813f2c',
    gameUrl: 'https://txlive.789games.net/',
    posterSrc: '/assets/images/components/live-casino/livestream/tai-xiu-5.webp',
    level: { min: 1, max: 10_000 }
  },
  {
    id: 'G1X_306',
    title: 'Xóc Đĩa Live Bàn 5',
    provider: '789',
    streamId: '7MhcV-fwQ2N',
    groupId: 'fd2186c3-26f3-40ac-9864-4287052b0ec3',
    gameUrl: 'https://xdlive.789games.net/',
    posterSrc: '/assets/images/components/live-casino/livestream/xoc-dia-5.webp',
    level: { min: 1, max: 10_000 }
  }
]

const route = useRoute()
const { isMobile } = useDevice()
const { modules } = useSwiper()

useHead({ script: [{ src: 'https://demo.nanocosmos.de/nanoplayer/api/release/nanoplayer.4.min.js' }] })
</script>

<template>
  <div :class="['livestream', { 'livestream--mobile': isMobile }]">
    <div :class="['base-title', 'd-flex justify-content-between mb-2', { mobile: isMobile }]">
      <h2 class="base-title__text">LIVESTREAM</h2>

      <div class="d-flex align-items-center gap-4">
        <NuxtLink v-if="route.path !== LIVE_CASINO_PATH" :to="LIVE_CASINO_PATH" class="button-link">
          Xem tất cả
        </NuxtLink>

        <SliderNavigation v-if="!isMobile" />
      </div>
    </div>

    <Swiper
      :modules="modules"
      :slidesPerView="isMobile ? 1 : 3"
      spaceBetween="24"
      :navigation="{ nextEl: '.livestream .slider-navigation__next', prevEl: '.livestream .slider-navigation__prev' }"
      :pagination="isMobile ? { clickable: true } : false"
    >
      <SwiperSlide v-for="stream in streams" :key="stream.id">
        <LiveStreamCard v-bind="stream" />
      </SwiperSlide>
    </Swiper>
  </div>
</template>

<style lang="scss" scoped>
.livestream {
  margin: 24px 0;

  .swiper-slide {
    @media screen and (min-width: 768px) {
      width: calc((100% - 48px) / 3) !important;
    }
    margin-right: 20px;
  }
  &--mobile {
    @include slider-progress-pagination;
  }
}
</style>
